import { Link } from 'react-router-dom';

import { BrandMarkIcon, ChevronRightIcon } from '@/components/Icons';

export function NotFoundPage() {
  return (
    <div className="app-root">
      <div className="ambient-glow one" />
      <div className="ambient-glow two" />
      <div className="ambient-glow three" />

      <div className="page-shell">
        <div className="page-shell-inner">
          <div className="page-surface">
            <div className="section">
              <div className="panel center-panel">
                <div className="brand-mark" aria-hidden="true">
                  <BrandMarkIcon />
                </div>
                <h1 className="display-title compact">
                  <span>Page not</span>
                  <span>found</span>
                </h1>
                <p className="copy center">
                  The route you opened does not exist in this PWA. Use the dashboard navigation to get back into the
                  app.
                </p>
                <div className="button-row hero-actions center">
                  <Link className="primary-button" to="/dashboard">
                    Go home
                    <ChevronRightIcon size={16} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
